const roleList = () => import("@/pages/permission/role/index.vue");
const roleForm = () => import("@/pages/permission/role/form.vue");
const roleConfig = () => import("@/pages/permission/role/config.vue");

export default [
    {
        path: "/permission/role/list",
        component: roleList,
        meta: [
            {
                name: "权限管理",
            },
            {
                name: "角色列表",
                activeRoute: "/permission/role/list",
            },
        ],
    },
    {
        path: "/permission/role/form",
        component: roleForm,
        meta: [
            {
                name: "权限管理",
            },
            {
                name: "角色列表",
                url: "/permission/role/list",
            },
            {
                name: "添加/编辑",
                activeRoute: "/permission/role/list",
            },
        ],
    },
    {
        path: "/permission/role/config",
        component: roleConfig,
        meta: [
            {
                name: "权限管理",
            },
            {
                name: "角色列表",
                url: "/permission/role/list",
            },
            {
                name: "配置权限",
                activeRoute: "/permission/role/list",
            },
        ],
    },
];
